import { render, staticRenderFns } from "./NuxPaywall.vue?vue&type=template&id=799e000e&scoped=true&"
import script from "./NuxPaywall.vue?vue&type=script&lang=ts&"
export * from "./NuxPaywall.vue?vue&type=script&lang=ts&"
import style0 from "./NuxPaywall.vue?vue&type=style&index=0&id=799e000e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799e000e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('799e000e', component.options)
    } else {
      api.reload('799e000e', component.options)
    }
    module.hot.accept("./NuxPaywall.vue?vue&type=template&id=799e000e&scoped=true&", function () {
      api.rerender('799e000e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/NuxPaywall.vue"
export default component.exports